<template>
  <v-container>
    <div>
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div class="" v-show="showTable">
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"></FilterForm>
    </div>

    <v-divider class="mt-2"></v-divider>
    <v-data-table v-if="showTable" class="mt-6" :headers="headers" :items="items" item-key="SKU" :single-expand="true"
      :expanded.sync="expanded" show-expand :search="search" :options.sync="options" :server-items-length="totalItems"
      :loading="loading" :footer-props="{
        'items-per-page-options': [50, 100, 150, 200, 500],
      }" dense height="65vh" fixed-header>
      <template v-slot:top>
        <v-text-field v-model="search" label="Search..." class="mb-1" outlined dense hide-details="auto"></v-text-field>
      </template>
      <template v-slot:[`item.Photos`]="{ item }">
        <tr v-for="(itm, p) in item.Photos" :key="p">
          <td v-if="p === 0">
            <v-img max-width="100px" :src="itm"></v-img>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-btn :id="item.SKU" color="#127897" outlined text @click="openEditDialog(item)">
          Review
          <v-icon> mdi-eye-outline </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Brand`]="{ item }">
        <tr>
          <td>
            <span>{{ item.Brand }}</span><br />
            <span class="grey--text"> Currency: {{ item.Currency }} </span>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.stock`]="{ item }">
        <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
          {{ item.stock }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="40" @click="openHistory(item)" color="accent">mdi-eye-circle</v-icon>
          </template>
          <span>View product history</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length">
          <v-row class="mt-4 pb-0" style="font-weight: 700">
            <v-col cols="3" v-if="changedValues.length > 0">CHANGED VALUES:</v-col>
            <v-col cols="2" v-if="removedValues.length > 0">REMOVED VALUES:</v-col>
            <v-col cols="2" v-if="addedValues.length > 0">ADDED VALUES:</v-col>
          </v-row>

          <v-row class="mt-0 mb-4">
            <v-col cols="3" class="py-0" v-if="changedValues.length > 0">
              <v-simple-table style="background-color: #c5cae9" dense>
                <template v-slot:default>
                  <thead style="background-color: #7986cb">
                    <tr>
                      <th class="text-left">Key</th>
                      <th class="text-left">From</th>
                      <th class="text-left">To</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(el, j) in changedValues" :key="j">
                      <td>
                        {{ el.name }}
                      </td>
                      <td>
                        {{ el.from }}
                      </td>
                      <td>
                        {{ el.to }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col cols="2" class="py-0" v-if="removedValues.length > 0">
              <v-simple-table style="background-color: #ffcdd2" dense>
                <template v-slot:default>
                  <thead style="background-color: #e57373">
                    <tr>
                      <th class="text-left">Key</th>
                      <th class="text-left">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in removedValues" :key="i">
                      <td>
                        {{ item.key }}
                      </td>
                      <td>
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col cols="2" class="py-0" v-if="addedValues.length > 0">
              <v-simple-table style="background-color: #c8e6c9" dense>
                <template v-slot:default>
                  <thead style="background-color: #66bb6a">
                    <tr>
                      <th class="text-left">Key</th>
                      <th class="text-left">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in addedValues" :key="i">
                      <td>
                        {{ item.key }}
                      </td>
                      <td>
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="2" class="py-0" v-if="newColor != ''">
              <v-alert dense outlined type="error">
                Added new color which does not exist!
                <p>
                  Color name:
                  <strong> {{ newColor }}</strong>
                </p>
              </v-alert>
            </v-col>
            <v-col v-if="fakesAlert.length > 0" cols="3" class="py-0">
              <v-alert text outlined color="deep-orange" icon="mdi-fire">
                <h3>FAKES ALERT</h3>
                <v-simple-table color="deep-orange" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(item, i) in fakesAlert" :key="i">
                        <td>
                          <strong>{{ item.key }}: </strong>
                        </td>
                        <td>
                          {{ item.value }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-alert>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>

    <ProductDialog v-if="showProductForm" :product="product" :title="title" :type="type" :fillDynamic="true"
      :excludeKeys="excludeKeys" @closeDialog="closeDialog" @closedStatusDialog="formatFilterValues"
      @hideTable="hideTable">
    </ProductDialog>

    <ProductHistoryDialog :product="productForHistory" ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import ProductDialog from "../ProductDialog/ProductDialog.vue";
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";

export default {
  name: "RequiresAttention",
  props: {},
  components: {
    ProductDialog,
    FilterForm,
    ProductHistoryDialog,
  },
  data: () => ({
    headers: [
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "STOCK", value: "stock", class: "footer" },
      { text: "ACTIONS", value: "edit", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    search: "",
    showProductForm: false,
    product: {},
    title: "",
    type: "",
    excludeKeys: [],
    showTable: true,
    productForHistory: {},
    // NEW PROPERTIES FOR PAGINATION
    options: {},
    totalItems: 0,
    currentFilters: [],
    loading: false,
  }),
  computed: {
    changedValues() {
      let values = [];
      if (this.expanded.length > 0) {
        for (let arr of this.expanded[0].AttentionMessage) {
          for (let item of arr) {
            if (typeof item === "object")
              for (const [key, value] of Object.entries(item)) {
                if (
                  key != "FakeAlert" &&
                  key != "Composition" &&
                  key != "Added" &&
                  key != "Removed" &&
                  key != "Photos" &&
                  key != "descriptionType"
                ) {
                  if (Array.isArray(value.From)) {
                    values.push({
                      name: key,
                      from: value.From[0],
                      to: value.To[0],
                    });
                  } else {
                    values.push({ name: key, from: value.From, to: value.To });
                  }
                }
              }
          }
        }
      }
      return values;
    },

    addedValues() {
      let values = [];
      if (this.expanded.length > 0) {
        for (let arr of this.expanded[0].AttentionMessage) {
          for (let item of arr) {
            if (typeof item === "object")
              for (const [key, value] of Object.entries(item)) {
                if (key === "Added" && key != "Photos") {
                  if (
                    value.key != "descriptionType" &&
                    value.key != "Composition"
                  ) {
                    if (Array.isArray(value.Value)) {
                      values.push({ key: value.key[0], value: value.Value[0] });
                    } else {
                      values.push({ key: value.key, value: value.Value });
                    }
                  }
                }
              }
          }
        }
      }
      return values;
    },

    removedValues() {
      let values = [];
      if (this.expanded.length > 0) {
        for (let arr of this.expanded[0].AttentionMessage) {
          for (let item of arr) {
            if (typeof item === "object")
              for (const [key, value] of Object.entries(item)) {
                if (key === "Removed" && key != "Photos") {
                  if (
                    value.key != "descriptionType" &&
                    value.key != "Composition"
                  ) {
                    if (Array.isArray(value.Value)) {
                      values.push({ key: value.key, value: value.Value[0] });
                    } else {
                      values.push({ key: value.key, value: value.Value });
                    }
                  }
                }
              }
          }
        }
      }
      return values;
    },

    fakesAlert() {
      let values = [];
      if (this.expanded.length > 0) {
        for (let arr of this.expanded[0].AttentionMessage) {
          for (let item of arr) {
            if (typeof item === "object")
              for (const [key, value] of Object.entries(item)) {
                if (key === "FakeAlert") {
                  for (const [key1, value1] of Object.entries(value)) {
                    values.push({ key: key1, value: value1 });
                  }
                }
              }
          }
        }
      }
      return values;
    },
    newColor() {
      let color = "";
      if (this.expanded.length > 0) {
        for (let arr of this.expanded[0].AttentionMessage) {
          for (let item of arr) {
            if (typeof item === "string") {
              color = item.split(":")[1];
            }
          }
        }
      }
      return color;
    },
  },
  watch: {
    realColor(val) {
      if (val === null) {
        this.realColor = "";
      }
    },
    // NEW WATCHER FOR PAGINATION
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  methods: {
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    openEditDialog(item) {
      this.product = item;

      this.title = "Resolve product " + item.SKU;
      this.type = "resolve";

      this.showProductForm = true;
    },
    closeDialog() {
      this.showProductForm = false;
    },
    closedStatusInProduct() { },

    formatFilterValues(filters) {
      this.showProductForm = false;
      this.showTable = true;
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["ExportState", "equals", "Requires Attention"]);
      finalData.push(["Described", "equals", true]);

      if (filters) {
        if (filters.length > 0) {
          for (let obj of filters) {
            if (obj.condition == "Yes") {
              val = true;
            } else if (obj.condition == "No") {
              val = false;
            } else if (obj.property["type"] === "Number") {
              val = parseInt(obj.value);
            } else if (obj.property["type"] === "Array") {
              val = obj.value;
            } else {
              val = obj.value;
            }
            finalData.push([obj.property["name"], obj.condition, val]);
          }
        }
      }

      // NEW: Store filters for pagination
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
   filterProducts(data) {
  // Get pagination params
  const { page, itemsPerPage } = this.options;
  
  // Set loading state
  this.loading = true;
  
  this.$store
    .dispatch("filterProducts", {
      filters: data,
      page: page || 1,
      limit: itemsPerPage || 100
    })
    .then((response) => {
      // Handle new response format with pagination
      if (response.data.data) {
        this.items = response.data.data;
        this.totalItems = response.data.pagination?.total || response.data.data.length;
      } else {
        // Fallback for old format
        this.items = response.data;
        this.totalItems = response.data.length;
      }
      
      this.loading = false;
      this.$refs.filterComponent.setLoading(false);
    })
    .catch((error) => {
      this.loading = false;
      this.$refs.filterComponent.setLoading(false);
      let errorMsg = "";
      errorMsg = error.response.data
        ? error.response.data
        : "Something went wrong while filtering.";

      this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
      console.log(error);
      this.items = [];
    });
},
    hideTable() {
      this.showTable = false;
    },
  },
  mounted() {
    this.formatFilterValues();
  },
};
</script>